export { ModifyContentOnlySectionMenuItem } from './modify-content-lock-menu-item';
